/**
 * Typed exceptions mirroring Flutter `core/exceptions/`.
 * The ApiClient interceptor maps backend responses onto these so callers can
 * `instanceof` check the failure mode the same way Dart code does.
 */

export class ApiException extends Error {
  readonly status: number;
  readonly code?: string;
  readonly fieldErrors?: Record<string, string>;
  readonly raw?: unknown;

  constructor(
    message: string,
    status: number,
    opts: { code?: string; fieldErrors?: Record<string, string>; raw?: unknown } = {}
  ) {
    super(message);
    this.name = 'ApiException';
    this.status = status;
    this.code = opts.code;
    this.fieldErrors = opts.fieldErrors;
    this.raw = opts.raw;
  }
}

export class ValidationException extends ApiException {
  constructor(message: string, fieldErrors: Record<string, string>, raw?: unknown) {
    super(message, 422, { fieldErrors, raw });
    this.name = 'ValidationException';
  }
}

export class AuthException extends ApiException {
  constructor(message: string, status = 401, raw?: unknown) {
    super(message, status, { raw });
    this.name = 'AuthException';
  }
}

export class NetworkException extends ApiException {
  constructor(message = 'Network error') {
    super(message, 0);
    this.name = 'NetworkException';
  }
}

export class ServerException extends ApiException {
  constructor(message: string, status = 500, raw?: unknown) {
    super(message, status, { raw });
    this.name = 'ServerException';
  }
}
